<div class="video-container">
  <dgx-video-player
    [resourceId]="input.resourceId"
    [resourceUrl]="input.videoInfo.videoUrl"
    [resourceTitle]="input.title"
    [videoType]="input.videoInfo.videoType"
  ></dgx-video-player>
</div>
